// AuthState
export interface FetchedAuthenticationProps {
  authenticated: boolean;
  authorities: string[];
  authorized: boolean;
  externalId?: string;
  id: number;
  name?: string;
  personId?: number;
  photoUrl?: number;
  provider?: string;
  restorable?: boolean;
  roles: UserRole[];
  settings: Record<string, any>;
  simulation?: boolean;
  switched?: boolean;
  username?: string;
}

export enum UserRole {
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  ADMIN = "ADMIN",
  SERVICE_ACCOUNT = "SERVICE_ACCOUNT",
  CLIENT = "CLIENT",
  USER = "USER"
}

export const ADMIN_ROLES: UserRole[] = [UserRole.ADMIN, UserRole.SYSTEM_ADMIN];

export interface FetchedAuthenticationConfigRegistrationProps {
  id: string;
  label: string;
  url: string;
  hidden: false;
}

export interface FetchedAuthenticationConfigProps {
  customerSignature: string;
  environment: string;
  defaultLoginUrl?: string;
  registrations: FetchedAuthenticationConfigRegistrationProps[];
}

export interface AuthenticationConfigRegistrationProps
  extends FetchedAuthenticationConfigRegistrationProps {
  name: string;
  type: string;
}

export interface AuthenticationConfigProps
  extends Omit<FetchedAuthenticationConfigProps, "registrations"> {
  registrations: AuthenticationConfigRegistrationProps[];
}

export interface FetchedLogoutProps {
  logoutUrl: string;
}
